import cn from 'classnames'
import styles from '../vacancy.module.scss'
import React from 'react'
import VacancyIconsInfo from './VacancyIconsInfo'

const VacancyFooter = ({ vacancy, appliedJobs, isAdmin, loading, setLoading, count, isOpen }) => {
  return (
    <div className={styles.vacancyShortInfo}>
      <div className={styles.header}>
        <VacancyIconsInfo type={'sea'} vacancy={vacancy} />
      </div>
    </div>
  )
}
export default VacancyFooter
